export interface IBillingProduct {
  id: string;
  appleProductId: string;
  googleProductId: string;
  amazonProductId: string;
  cafebazaarProductId: string;
  myketProductId: string;
  huaweiProductId: string;
  samsungProductId: string;
  xiaomiProductId: string;
  type: 'subscription' | 'one_time';
  planLevel: number;
  displayName: string;
  priceUsd: number;
}

export interface IBillingDiscount {
  title: string;
  type: 'percentage' | 'amount';
  value: number;
}

export interface IBillingAppleVars {
  apiKeyId: string;
  apiIssuerId: string;
}

export interface IBillingVars {
  apple: IBillingAppleVars;
  googlePackageName: string;
  cafebazaarPackageName: string;
  cafebazaarRsaKey: string | null;
  myketRsaKey: string | null;
  products: IBillingProduct[];
  activeDiscount: IBillingDiscount | null;
  serviceApiKey: string;
}

export const billingVars: IBillingVars = {
  apple: {
    apiKeyId: '6WNZ76XNR3',
    apiIssuerId: 'e7af2e10-0eb5-4dac-83cb-3c070ccf4f5f',
  },
  googlePackageName: 'com.yocoolmate.app',
  cafebazaarPackageName: 'com.yocoolmate.app.cafebazaar',
  cafebazaarRsaKey:
    'MIHNMA0GCSqGSIb3DQEBAQUAA4G7ADCBtwKBrwDYFeB+cwWDWzBZK9Uw60lR5YexRPxb0a+sBeeukZfqSJBi3l2sHRjRxeUM5HS1lTCz6Ya5Sc41HFzzuqItZkP+LnM74CsvDY0/DjpvzBopZBVikWmQU2Vx2fapBSGjd7HBn/6f21lzwUWTJ0T/DxNw3C32vOSsmGBwAo14aChK7+Z1JnMWHqIxdfAdZMkWxVO1/AtJZO4PU1d3SrlNITTOYHd0IawuY5GVbJm4Dm8CAwEAAQ==',
  myketRsaKey:
    'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCx5zIIhYsoaBdZuHT+NwRl4+IZoGXe4c5DHhKIzCBEjXCtdiARgGck3I2orIHwzy9erGw1esMeeklx2I6OSbs+14GjjkjI/LfKcvitlUhhp+n00NcOhMQ6EGd8auRz5qv4RyXe7c7xmAQjIvOadA+BgxHtHclfGs3/6ymj/duARQIDAQAB',
  products: [
    {
      id: 'pro_monthly',
      appleProductId: 'com.yocoolmate.app.monthly',
      googleProductId: 'com.yocoolmate.app.monthly',
      amazonProductId: 'com.yocoolmate.app.monthly',
      cafebazaarProductId: 'com.yocoolmate.app.monthly',
      myketProductId: 'com.yocoolmate.app.monthly',
      huaweiProductId: 'com.yocoolmate.app.monthly',
      samsungProductId: 'com.yocoolmate.app.monthly',
      xiaomiProductId: 'com.yocoolmate.app.monthly',
      type: 'subscription',
      planLevel: 1,
      displayName: 'Pro Monthly',
      priceUsd: 999,
    },
    {
      id: 'pro_yearly',
      appleProductId: 'com.yocoolmate.app.yearly',
      googleProductId: 'com.yocoolmate.app.yearly',
      amazonProductId: 'com.yocoolmate.app.yearly',
      cafebazaarProductId: 'com.yocoolmate.app.yearly',
      myketProductId: 'com.yocoolmate.app.yearly',
      huaweiProductId: 'com.yocoolmate.app.yearly',
      samsungProductId: 'com.yocoolmate.app.yearly',
      xiaomiProductId: 'com.yocoolmate.app.yearly',
      type: 'subscription',
      planLevel: 1,
      displayName: 'Pro Yearly',
      priceUsd: 4999,
    },
    {
      id: 'pro_lifetime',
      appleProductId: 'com.yocoolmate.app.forever',
      googleProductId: 'com.yocoolmate.app.forever',
      amazonProductId: 'com.yocoolmate.app.forever',
      cafebazaarProductId: 'com.yocoolmate.app.lifetime',
      myketProductId: 'com.yocoolmate.app.forever',
      huaweiProductId: 'com.yocoolmate.app.forever',
      samsungProductId: 'com.yocoolmate.app.forever',
      xiaomiProductId: 'com.yocoolmate.app.forever',
      type: 'one_time',
      planLevel: 1,
      displayName: 'Pro Lifetime',
      priceUsd: 9999,
    },
    {
      id: 'pro_unlimited',
      appleProductId: '',
      googleProductId: '',
      amazonProductId: '',
      cafebazaarProductId: 'com.yocoolmate.app.unlimited',
      myketProductId: 'com.yocoolmate.app.unlimited',
      huaweiProductId: '',
      samsungProductId: '',
      xiaomiProductId: '',
      type: 'one_time',
      planLevel: 1,
      displayName: 'Pro Unlimited',
      priceUsd: 0,
    },
  ],
  activeDiscount: {
    title: 'Founding Member',
    type: 'percentage',
    value: 50,
  },
  serviceApiKey: 'billing-svc-4c8d1e6b2a9f7503',
};
